import {createUseStyles} from "react-jss";
import {colors, space} from "../../theme";

export const useStyles = createUseStyles({
    component: {
        display: "flex",
        flexDirection: "column",
        gap: space(8),
    },
    time: {
        display: "flex",
        flexWrap: "wrap",
        gap: space(8),
    },
    deleteFilter: {
        width: "100%",
        "--on-button-color": colors.delete,
        "--on-button-hover-color": colors.delete,
    }
});